var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: _vm.color,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            fill: "none"
          }
        },
        [
          _c("path", { attrs: { d: "M12 19V5" } }),
          _c("path", { attrs: { d: "M5 12L12 5L19 12" } })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }